import React from 'react';
import PropTypes from 'prop-types';
// logic
import { useTranslation } from 'react-i18next';
import { constants as loadConstants } from 'utils/loads';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { actions as loadsActions } from 'state/loads';
import loadSelectors from 'state/loads/selectors';
// styles
import styled from 'styled-components';
import { Switch } from 'refactored/ui/form';

const LoadType = ({ className, shipmentKey, loadKey }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('loads');

  const { PALLET, NON_PALLETIZED } = loadConstants.BUTTON_TYPES;
  const loadType = useSelector((state) =>
    loadSelectors.getLoadType(state, shipmentKey, loadKey)
  );
  const selectedButton =
    loadType === loadConstants.LOAD_TYPES.PALLET ? PALLET : NON_PALLETIZED;

  const selectedLoadType = selectedButton
    ? selectedButton
    : loadConstants.BUTTON_TYPES.PALLET;

  const handleChange = (selectedValue) => {
    dispatch(
      loadsActions.changeLoadType({
        shipmentKey,
        loadKey,
        value: selectedValue,
        field: loadConstants.FIELDS.LOAD_TYPE,
      })
    );
  };

  const options = [
    {
      label: t('load_type_pallet'),
      value: PALLET,
      onClick: () => handleChange(loadConstants.LOAD_TYPES.PALLET),
    },
    {
      label: t('load_type_non_pallet'),
      value: NON_PALLETIZED,
      onClick: () => handleChange(loadConstants.LOAD_TYPES.NON_PALLETIZED),
    },
  ];

  return (
    <Switch className={className} value={selectedLoadType} options={options} />
  );
};

LoadType.propTypes = {
  className: PropTypes.string,
  shipmentKey: PropTypes.string.isRequired,
  loadKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default styled(LoadType)``;
